import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import { AttendanceMonthlyView } from "@/components/AttendanceMonthlyView";

export default function AttendanceSheet() {
  const { userId } = useParams();
  const nav = useNavigate();
  const [name, setName] = useState("");

  useEffect(() => {
    const m = new Date().toISOString().slice(0, 7);
    api.get(`/attendance/monthly?month=${m}&user_id=${userId}`).then((r) => setName(r.data.user_name)).catch(() => {});
  }, [userId]);

  return (
    <div className="space-y-6" data-testid="attendance-sheet-page">
      <button onClick={() => nav(-1)} className="flex items-center gap-2 text-muted-foreground hover:text-foreground text-sm"><ArrowLeft size={16} /> Zpět</button>
      <div>
        <h1 className="text-3xl font-black tracking-tighter uppercase">Výkaz docházky</h1>
        {name && <p className="text-muted-foreground">{name}</p>}
      </div>
      <AttendanceMonthlyView userId={userId} />
    </div>
  );
}
